<script>
import Layout from '@layouts/main'
import LoginSidebar from '@components/login-sidebar'
import { authMethods, authComputed } from '@state/helpers'

export default {
  components: { Layout, LoginSidebar },
  metaInfo: {
    title: 'Reset Password',
    meta: [{ name: 'description', content: 'Reset Password' }],
  },
  data() {
    return {
      tokenId: this.$route.query.token,
      authError: null,
      newPassword: null,
      isWorking: false,
      oldPassword: null,
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...authMethods,
    tryToResetPassword() {
      this.authError = null
      this.isWorking = true

      return this.resetPassword({
        tokenId: this.tokenId,
        newPassword: this.newPassword,
        userId: this.currentUser ? this.currentUser.id : null,
        oldPassword: this.oldPassword,
      })
        .then(response => {
          this.isWorking = false

          if (this.loggedIn) {
            this.$router.push({ name: 'profile' })
          } else {
            this.$router.push({ name: 'login' })
          }
        })
        .catch(error => {
          this.isWorking = false
          if (typeof error === 'string') {
            this.authError = error
          } else if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            this.authError = error.response.data.error
          } else {
            this.authError = 'An error occurred resetting your password'
          }
        })
    },
  },
}
</script>

<template>
  <Layout row class="pa-0">
    <LoginSidebar />

    <v-flex xs7 class="main">
      <v-layout fill-height justify-center>
        <v-flex sm7 class="form">
          <h2>{{ !currentUser ? 'Set' : 'Reset' }} Password</h2>
          <v-form :class="$style.form" @submit.prevent="tryToResetPassword">
            <v-text-field
              v-if="!tokenId"
              v-model="oldPassword"
              name="oldPassword"
              type="password"
              placeholder="Old Password"
            ></v-text-field>
            <v-text-field
              v-model="newPassword"
              name="newPassword"
              type="password"
              placeholder="New Password"
            ></v-text-field>
            <v-btn
              depressed
              block
              primary
              class="btn-blue"
              :disabled="isWorking"
              type="submit"
            >
              <BaseIcon v-if="isWorking" name="sync" spin />
              <span v-else>{{ !currentUser ? 'Set' : 'Reset' }} Password</span>
            </v-btn>
            <p v-if="authError">{{ authError }}</p>
          </v-form>
        </v-flex>
      </v-layout>
    </v-flex>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.form {
  text-align: center;
}
</style>
